<template>
  <table class="table table-details">
    <tr>
      <td><label>{{ $t('generic.id') }}</label></td>
      <td>{{ details.id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.status') }}</label></td>
      <td>{{ details.tap_status }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('externalEmvTaps.details.tenant_operator') }}</label></td>
      <td>{{ details.tenant_operator }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('externalEmvTaps.details.tap_id') }}</label></td>
      <td>{{ details.tap_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('externalEmvTaps.details.token') }}</label></td>
      <td>{{ details.token }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('externalEmvTaps.details.masked_pan') }}</label></td>
      <td>{{ details.masked_pan }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('externalEmvTaps.details.par') }}</label></td>
      <td>{{ details.par }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('externalEmvTaps.details.device_id') }}</label></td>
      <td>{{ details.device_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('externalEmvTaps.details.device_dttm') }}</label></td>
      <td>{{ details.device_dttm | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('externalEmvTaps.details.server_dttm') }}</label></td>
      <td>{{ details.server_dttm | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('externalEmvTaps.details.request_id') }}</label></td>
      <td>{{ details.request_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('externalEmvTaps.details.trip_data') }}</label></td>
      <td>
        <meta-data-details :data="details.trip_data"/>
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('externalEmvTaps.details.linked') }}</label></td>
      <td>{{ details.linked | trueFalse }}
        <span v-if="details.emv_tap">
          (<router-link :to="{name: 'account-emv-tap-details', params: {id: details.emv_tap.account_id, resource_id: details.emv_tap.id}}">
          {{ details.emv_tap.id }}
        </router-link>)
        </span>
        </td>
    </tr>
  </table>
</template>
<script>
import MetaDataDetails from "src/components/MetaData/MetaDataDetails";

export default {

  name: 'ExternalEmvTapDetails',
  components: {
    MetaDataDetails
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  computed: {}
};
</script>
<style></style>
